import { fmtTimeHM } from "@extensions/convert";
import { useState } from "react";
import dayjs from "dayjs";
import { statusTag } from "@extensions/design";

/** Запись в таблице записей */
const RecordsItem = ({item, left, top, width, height, onClick, timeColWidth, userColWidth, headerRowHeight, hourRowHeight, todayUsers, updateRecordOnServer, hourStart = 7 }) => {
  const [isDragging, setIsDragging] = useState(false);

  const className = "records-item" + (item.deleted ? " records-item-deleted" : "");

  // Обработчики drag and drop
  const handleDragStart = (e) => {
    setIsDragging(true);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', JSON.stringify({
      id: item.id,
      start: item.start ? item.start.format('HH:mm') : null,
      finish: item.finish ? item.finish.format('HH:mm') : null,
      userId: item.userId,
      roomId: item.roomId
    }));
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e) => {
    e.preventDefault();
    try {
      const dragData = JSON.parse(e.dataTransfer.getData('text/plain'));
      if (dragData.id === item.id) return; // Нельзя перетащить на себя
      
      // Определяем новую позицию на основе координат drop
      const rect = e.currentTarget.getBoundingClientRect();
      const dropX = e.clientX - rect.left;
      const dropY = e.clientY - rect.top;
      
      // Вычисляем новый столбец (сотрудник/зал)
      const newColumnIndex = Math.floor((dropX - timeColWidth) / userColWidth);
      const newUser = todayUsers[newColumnIndex];
      
      // Вычисляем новое время с шагом 15 минут
      const relativeY = dropY - headerRowHeight;
      const minutesFromStart = (relativeY / hourRowHeight) * 60;
      const roundedMinutes = Math.round(minutesFromStart / 15) * 15;
      const newStart = dayjs().startOf('day').add((hourStart ?? 0) * 60 + roundedMinutes, 'minute');
      
      // Вычисляем новое время окончания (сохраняем длительность)
      const duration = dragData.finish && dragData.start
        ? dayjs(dragData.finish, 'HH:mm').diff(dayjs(dragData.start, 'HH:mm'), 'minute')
        : 60; // Если finish null, длительность = 1 час
      const newFinish = newStart.add(duration, 'minute');

      console.log(duration,newFinish)

      // Вызываем функцию обновления
      updateRecordOnServer && updateRecordOnServer(dragData.id, {
        newUserId: newUser?.id,
        newStart: newStart,
        newFinish: newFinish
      });
    } catch (error) {
      console.error('Error handling drop:', error);
    }
  };

  return<div 
    className={className + (isDragging ? " records-item-dragging" : "")} 
    style={{left, top, width, height, minHeight: height}} 
    onClick={() => onClick(item.id)}
    draggable={true}
    onDragStart={handleDragStart}
    onDragEnd={handleDragEnd}
    onDragOver={handleDragOver}
    onDrop={handleDrop}
  >
    <div className="record-item-title"><div># {item.id}</div><div>{statusTag(item.status)}</div></div>
    <div className="record-item-time">
      {item.start ? fmtTimeHM(item.start) : ''} - {item.finish ? fmtTimeHM(item.finish) : ''}
    </div>
    <div>{item.predName}</div>
    <div>{item.predPhone}</div>
    <div>{item.predAddress}</div>
    <div>{item.osn}</div>
    <div>{item.comment}</div>
  </div>
}

export default RecordsItem;